// Sites translations for React Admin resource
export const sitesResource = {
  name: 'Charging Sites',
  fields: {
    id: 'ID',
    name: 'Name',
    siteName: 'Site Name',
    premisesName: 'Premises Name',
    vendor: 'Vendor',
    vendorName: 'Vendor',
    merchant: 'Merchant',
    address: 'Address',
    latitude: 'Latitude',
    longitude: 'Longitude',
    parkingInfo: 'Parking Information',
    parkingWeekdayRate: 'Weekday Rate',
    parkingWeekendRate: 'Weekend Rate',
    parkingPublicHolidayRate: 'Public Holiday Rate',
    parkingFreeMinutes: 'Free Parking Minutes',
    parkingPromotion: 'Promotion/Discount',
    restrictions: 'Restrictions',
    heightLimit: 'Height Limit',
    security: 'Security',
    restrictionNotes: 'Additional Restrictions',
    location: 'Location',
    district: 'District',
    addressLine1: 'Address Line 1',
    addressLine2: 'Address Line 2',
    city: 'City',
    state: 'State/Province',
    postalCode: 'Postal Code',
    country: 'Country',
    region: 'Region',
    timezone: 'Timezone',
    phone: 'Phone',
    email: 'Email',
    supportPhone: 'Support Phone',
    website: 'Website',
    accessType: 'Access Type',
    isActive: 'Active',
    chargerCount: 'Total Chargers',
    availableChargers: 'Available Chargers',
    currentTotalPower: 'Current Power Usage',
    totalMaxPower: 'Total Max Power (kW)',
    gridConnectionCapacity: 'Grid Capacity (kW)',
    parkingType: 'Parking Type',
    hasCanopy: 'Has Weather Protection',
    reservationEnabled: 'Reservations Enabled',
    emailReceiptEnabled: 'Send Email Receipts',
    appAccessEnabled: 'App Access',
    kioskAccessEnabled: 'Kiosk Access',
    primaryImage: 'Primary Image',
    images: 'Images',
    imageCaption: 'Image Caption',
    notes: 'Notes',
    amenities: 'Amenities',
    operatingHours: 'Operating Hours',
    operatingAccess: 'Hours Access Type',
    pricingInfo: 'Pricing Information',
    qrCode: 'QR Code',
    createdAt: 'Created At',
    updatedAt: 'Updated At',
  },
};

// Custom sites translations for components
export const sites = {
  accessTypes: {
    public: 'Public',
    private: 'Private',
    restricted: 'Restricted',
    undefined: 'Unknown',
  },
  operatingAccess: {
    '24_7': '24/7 Always Open',
    'daily': 'Daily (Same Hours)',
    'varies': 'Varies by Day',
    'restricted': 'Limited Access',
    'closed': 'Temporarily Closed',
  },
  parkingTypes: {
    street: 'Street Parking',
    garage: 'Parking Garage',
    lot: 'Parking Lot',
    dedicated: 'Dedicated EV Parking',
  },
  list: {
    title: 'Charging Sites',
    filters: {
      search: 'Search by name, address, or city',
      activeOnly: 'Show Active Only',
      accessType: 'Access Type',
      city: 'City',
      state: 'State',
    },
  },
  edit: {
    title: 'Edit Site',
    backToList: 'Back to Sites',
    basicInfo: 'Basic Information',
    contactInfo: 'Contact Information',
    accessStatus: 'Access & Status',
    chargerInfo: 'Charger Information',
    features: 'Features & Amenities',
    parkingRestrictions: 'Parking & Restrictions',
    additionalInfo: 'Additional Information',
    deleteSite: 'Delete Site',
    deleteSiteDescription: 'Permanently delete this charging site and all associated data',
    cannotDeleteWithChargers: 'Cannot delete site with existing chargers. Remove all chargers first.',
    activeSite: 'Active Site',
    postalCodeHelp: 'Optional in Hong Kong',
    deleteConfirmTitle: 'Delete Site',
    deleteConfirmWarning: 'Warning: This action cannot be undone.',
    deleteConfirmMessage: 'You are about to delete site',
    deleteConfirmInfo: 'All associated data will be permanently removed.',
    deleteConfirmPrompt: 'To confirm deletion, please type the site name',
    deleteConfirmPromptBelow: 'below:',
    deleteConfirmTypePlaceholder: 'Type "%{name}" to confirm',
    nameDoesNotMatch: 'Site name does not match',
    deleteButton: 'Delete Site',
    notesHelperText: 'Additional notes or special instructions about this site',
    primaryImageHelp: 'URL of the main site image',
    vendorHelperText: 'Select or change the merchant for this site',
    noMerchantAssigned: 'No merchant assigned',
    parkingWeekdayRateHelp: 'Rate in dollars per hour (e.g., 25 = $25/hr)',
    parkingWeekendRateHelp: 'Rate in dollars per hour (e.g., 30 = $30/hr)',
    publicHolidayRateHelp: 'Rate in dollars per hour for public holidays',
    freeMinutesHelp: 'Number of free minutes (0 = no free parking)',
  },
  create: {
    title: 'Create Site',
    subtitle: 'Add a new charging site location',
    infoMessage: 'Create a new charging site. You can add chargers to this site after it is created.',
    basicInfo: 'Basic Information',
    contactInfo: 'Contact Information',
    accessStatus: 'Access & Status',
    features: 'Features & Amenities',
    powerInfo: 'Power Information',
    parkingRestrictions: 'Parking & Restrictions',
    additionalInfo: 'Additional Information',
    nameHelperText: 'Descriptive name for the charging site',
    premisesNameHelperText: 'Name of the premises or building',
    latitudeHelperText: 'GPS latitude coordinate (e.g., 22.3193)',
    longitudeHelperText: 'GPS longitude coordinate (e.g., 114.1694)',
    addressHelperText: 'Primary street address',
    postalCodeHelperText: 'Optional for Hong Kong addresses',
    phoneHelperText: 'Contact phone number for the site',
    emailHelperText: 'Contact email for site inquiries',
    websiteHelperText: 'Website URL (e.g., https://example.com)',
    activeSite: 'Active Site',
    emailReceiptHelperText: 'When off, the receipt email and the "Receipt has been sent…" tail on the payment push are both suppressed',
    appAccessEnabledHelperText: 'Marks this premises as open to the mobile app. App enforcement is not live yet, so this does not yet change what app users see or where they can charge.',
    kioskAccessEnabledHelperText: 'Allow self-service kiosks to be enrolled at this premises',
    totalMaxPowerHelperText: 'Total maximum power capacity in kW',
    gridCapacityHelperText: 'Grid connection capacity in kW',
    notesHelperText: 'Additional notes or special instructions',
    primaryImageHelperText: 'URL of the main site image',
    qrCodeHelperText: 'Leave empty to auto-generate, or enter 4 characters (e.g., A3K9)',
    vendorHelperText: 'Select a merchant to associate with this site (optional)',
  },
  kioskBayWarning: {
    title: 'Some chargers will not appear on the kiosk',
    body: 'These chargers have no reference number, so the kiosk neither lists them nor can start a charge on them: %{names}.',
    andMore: 'and %{count} more',
    partial: 'Only the first %{count} chargers at this premises were checked.',
  },
  kioskSettings: {
    title: 'Kiosk reference number',
    intro: 'Every charger at this premises has a reference number. Choose what the kiosk calls it, for example "Bay B03" or "Charger B03".',
    presetLabel: 'Name',
    other: 'Other',
    singular: 'Name (one)',
    plural: 'Name (more than one)',
    singularHelper: 'Printed in front of one reference number, for example "Bay B03"',
    pluralHelper: 'Used for counts, for example "2 bays are plugged in"',
    save: 'Save',
    clear: 'Use the system-wide value',
    saved: 'Name saved for this premises',
    cleared: 'The premises name was cleared',
    source: {
      site: 'Set for this premises',
      partial: 'Partly set for this premises',
      inherited: 'Inherited',
    },
    inheritedHelper: 'Not set for this premises, so the system-wide value applies. The choice below is the built-in default, %{label} / %{plural}, which is not necessarily the value in use. Pick a different name to set one for this premises.',
    lengthError: 'Enter 1 to 20 characters',
    unchanged: 'No changes to save',
    unavailable: 'This server does not offer the kiosk reference number name yet.',
    loadError: 'Could not load the kiosk settings for this premises',
  },
  helpers: {
    primaryImage: 'Main image of the site (recommended size: 1200x800px)',
    images: 'Additional images (up to 10 images, recommended size: 1200x800px)',
    operatingAccess: 'Indicates the type of operating hours access for this site',
    parkingRate: 'e.g., "$25/hr" or "Free" or "Contact for rates"',
    parkingPromotion: 'e.g., "First 30 min free with charging"',
    heightLimit: 'e.g., "2.2m" or "No limit"',
    security: 'e.g., "24/7 CCTV" or "Security guard"',
    restrictionNotes: 'Any additional restrictions or requirements',
    amenities: 'Tap to toggle amenities available at this site. Selected items appear on the site detail page in the mobile app.',
  },
  amenityLabels: {
    wifi: 'WiFi',
    restroom: 'Restroom',
    restaurants: 'Restaurants',
    shopping: 'Shopping',
    covered_parking: 'Covered Parking',
    security_camera: 'Security Camera',
    valet_parking: 'Valet Parking',
    '24_7': '24/7',
    wheelchair: 'Wheelchair Accessible',
    cafe: 'Cafe',
    atm: 'ATM',
    pharmacy: 'Pharmacy',
    convenience_store: 'Convenience Store',
    gas_station: 'Gas Station',
    hotel: 'Hotel',
    gym: 'Gym',
    park: 'Park',
    bank: 'Bank',
    parking: 'Parking',
  },
  notifications: {
    deleteSuccess: 'Site deleted successfully',
    deleteError: 'Error deleting site',
    createSuccess: 'Site created successfully',
    updateSuccess: 'Site updated successfully',
    imageUploaded: 'Image uploaded successfully',
    imagesUploaded: '%{count} image(s) uploaded successfully',
    imageRemoved: 'Image removed',
  },
  actions: {
    uploadImages: 'Upload Images',
    uploadImage: 'Upload Image',
    changeImage: 'Change Image',
  },
  errors: {
    maxImagesExceeded: 'Maximum %{max} images allowed',
    uploadFailed: 'Image upload failed',
    invalidImageType: 'Invalid image type. Only PNG, JPEG, and SVG are supported.',
    imageTooLarge: 'Image is too large. Maximum size is 5MB.',
  },
  multilang: {
    title: 'Multilanguage Information',
    helperText: 'Provide translations for fields displayed in the mobile app. English is required.',
    nameHelperText: 'Site name in this language',
    addressHelperText: 'Address in this language (useful for different scripts)',
    notesHelperText: 'Notes or special instructions in this language',
    pricingInfoHelperText: 'Pricing information and details in this language',
    nonEnglishNote: 'This translation is optional. If not provided, the English version will be used.',
    copyFromBasic: 'Copy from Basic Information',
  },
  operatingHours: {
    title: 'Operating Hours',
    quickTemplates: {
      title: 'Quick Templates',
      247: '24/7',
      businessHours: 'Business Hours (9-5)',
      extendedHours: 'Extended Hours',
      clearAll: 'Clear All',
    },
    tabs: {
      individualDays: 'Individual Days',
      quickEdit: 'Quick Edit',
      preview: 'Preview',
    },
    days: {
      monday: 'Monday',
      tuesday: 'Tuesday',
      wednesday: 'Wednesday',
      thursday: 'Thursday',
      friday: 'Friday',
      saturday: 'Saturday',
      sunday: 'Sunday',
      mon: 'Mon',
      tue: 'Tue',
      wed: 'Wed',
      thu: 'Thu',
      fri: 'Fri',
      sat: 'Sat',
      sun: 'Sun',
    },
    timeFields: {
      open: 'Open',
      close: 'Close',
    },
    status: {
      closed: 'Closed',
      247: '24/7',
    },
    actions: {
      copyToAll: 'Copy to All',
      apply: 'Apply',
      selectDays: 'Select Days',
      setHours: 'Set Hours for Selected Days',
    },
    alerts: {
      selectMultipleDays: 'Select multiple days to apply the same hours',
    },
    publicHolidays: {
      title: 'Public Holidays',
      setDifferentHours: 'Set different hours for public holidays',
      closedOnPublicHolidays: 'Closed on public holidays',
      siteWillBeClosed: 'The site will be closed on all public holidays',
      publicHolidayHours: 'Public holiday hours: %{hours}',
    },
    specialDates: {
      title: 'Specific Special Dates',
      subtitle: 'Specific Special Dates (e.g., Christmas, New Year)',
      show: 'Show',
      hide: 'Hide',
      showSpecialDates: 'Specific Special Dates',
      addSpecialDate: 'Add Special Date',
      editSpecialDate: 'Edit Special Date',
      noSpecialDates: 'No specific dates configured. Add specific holidays (e.g., Dec 25 for Christmas) with custom hours.',
      dateLabel: 'Date',
      nameLabel: 'Name (e.g., Christmas Day, New Year)',
      closedOnThisDate: 'Closed on this date',
      cancel: 'Cancel',
      add: 'Add',
      update: 'Update',
    },
    preview: {
      hoursSummary: 'Hours Summary',
      displayPreview: 'Display Preview',
      everyDay: 'Every day',
      monFri: 'Mon-Fri',
      satSun: 'Sat-Sun',
      nextDay: '12:00 AM (next day)',
    },
  },
};